import { FETCH_SEARCH_RESULTS } from '../constants/actionTypes';

const searchResults = (searchResults = [], action) => {
  switch (action.type) {
    case FETCH_SEARCH_RESULTS:
      return action.payload;
    
    default:
      return searchResults;
  }
};

export default searchResults;